import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthGuard, GuestGuard } from "@/pages/auth/auth-guard";
import { LoginPage } from "@/pages/auth/login-page";
import { RegisterPage } from "@/pages/auth/register-page";
import { RegisterSuccessPage } from "@/pages/auth/register-success-page";
import { ForgotPasswordPage } from "@/pages/auth/forgot-password-page";
import { ResetPasswordPage } from "@/pages/auth/reset-password-page";
import { VerifyEmailPage } from "@/pages/auth/verify-email-page";
import { AuthErrorPage } from "@/pages/auth/auth-error-page";
import { DesktopConfirmPage } from "@/pages/auth/desktop-confirm-page";
import { DesktopHandoffPage } from "@/pages/auth/desktop-handoff-page";
import { WorkspacePage } from "@/pages/workspace-page";
import { DolcettoMediaPage } from "@/pages/dolcetto-media-page";
import { PreviewChromeDemoSeed } from "@/pages/preview-chrome-demo-seed";
import { SettingsPage } from "@/pages/settings-page";
import { LayoutProvider } from "@/components/layout/layout-provider";
import { MasterLayout } from "@/components/layout/master-layout";
import { ScreenSizeGuard } from "@/components/layout/screen-size-guard";
import { WorkshopRoutes } from "@/workshop/workshop-routes";
import { isTauri } from "@/lib/is-tauri";

import { BillingTrialNotice } from "@/components/settings/billing-trial-notice";

function App() {
  return (
    <BrowserRouter>
      {!isTauri() && <BillingTrialNotice />}
      {!isTauri() && <ScreenSizeGuard />}
      <Routes>
        {/* Auth pages — web only. In Tauri, sign-in is owned by the
            desktop AuthGate popover, so the SPA's login/register routes
            are unreachable UI that only confuses users (and would fail:
            they assume cookie sessions, not Keychain bearer tokens). */}
        {isTauri() ? (
          <Route path="/auth/*" element={<Navigate to="/" replace />} />
        ) : (
          <>
            <Route
              path="/auth/login"
              element={
                <GuestGuard>
                  <LoginPage />
                </GuestGuard>
              }
            />
            <Route
              path="/auth/register"
              element={
                <GuestGuard>
                  <RegisterPage />
                </GuestGuard>
              }
            />
            <Route
              path="/auth/register-success"
              element={
                <GuestGuard>
                  <RegisterSuccessPage />
                </GuestGuard>
              }
            />
            <Route
              path="/auth/forgot-password"
              element={
                <GuestGuard>
                  <ForgotPasswordPage />
                </GuestGuard>
              }
            />
            <Route
              path="/auth/reset-password/:uid/:token"
              element={<ResetPasswordPage />}
            />
            <Route
              path="/auth/verify-email/:key"
              element={<VerifyEmailPage />}
            />
            <Route
              path="/auth/desktop-confirm"
              element={<DesktopConfirmPage />}
            />
            <Route
              path="/auth/desktop-handoff"
              element={<DesktopHandoffPage />}
            />
            <Route path="/auth/error" element={<AuthErrorPage />} />
          </>
        )}

        {/* Preview route (no auth, for dev only) */}
        <Route
          path="/preview"
          element={
            <LayoutProvider>
              <MasterLayout>
                <PreviewChromeDemoSeed />
              </MasterLayout>
            </LayoutProvider>
          }
        />

        {/* Workshop — UI development sandbox (dev only, no auth) */}
        <Route path="/workshop/*" element={<WorkshopRoutes />} />
        <Route path="/here-media" element={<DolcettoMediaPage />} />

        {/* Protected routes */}
        <Route
          path="/settings"
          element={
            <AuthGuard>
              <SettingsPage />
            </AuthGuard>
          }
        />
        <Route
          path="/"
          element={
            <AuthGuard>
              <WorkspacePage />
            </AuthGuard>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
